import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>
        FTC Team <span>#19938</span> &mdash; Knights of the Ping Pong Table
        &mdash; <span>ftc19938.org</span>
      </p>
      <p>FIRST Tech Challenge &mdash; Grades 7–12 &mdash; {currentYear}</p>
    </footer>
  );
};

export default Footer;
